<template>
  <div class="coaches">
    <div class="section-background primary auto-height">
      <div class="container">
        <div class="hero">
          <div class="text">
            <p class="sub-title">
              Finding the right coach was never this easy
            </p>
            <h1 class="title">
              1-on-1 coaching from the world's best
            </h1>

            <div class="row usp-row">
              <div class="col-md-4">
                <div class="usp-holder">
                  <i class="material-icons">sports_cricket</i>

                  <p>Coaches You Can Trust</p>
                  <span>All of our coaches have extensive coaching experience and
                    are ICC, ECB, AUS, SA or BCCI certified coaches.</span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="usp-holder">
                  <i class="material-icons">account_balance_wallet</i>

                  <p>Easy Booking & Payment</p>
                  <span>Every coaching session can be booked in minutes through
                    Ludimos and all financial transactions are securely
                    processed online</span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="usp-holder">
                  <i class="material-icons">admin_panel_settings</i>

                  <p>
                    Good-Fit Guarantee
                  </p>
                  <span>We are committed to helping you find the right coach. Our
                    coaches are world class and well qualififed to assit you to
                    take you to the next level.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="listOfCoaches"
      class="section-background white"
    >
      <div class="container">
        <div class="row">
          <div class="page-title col-6 col-md-6">
            <h3>{{ totalRows }} coaches</h3>
          </div>
          <div
            v-if="coaches.length"
            class="sort-by col-12 col-md-6 text-right"
          >
            <b-form-select
              v-model="sortBy"
              :options="SortByOptions"
            />
          </div>
        </div>
        <div
          v-if="loading"
          class="loading-spinner"
        >
          <div
            class="spinner-border"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div v-else>
          <div v-if="!coaches.length">
            No coaches availble at this moment. Please come back later.
          </div>
          <div v-else>
            <div class="row">
              <div
                v-for="(coach, i) in coaches"
                :key="i"
                class="col-12 col-md-6 col-lg-4"
              >
                <div
                  class="coach-card"
                  @click="goToProfile(coach)"
                >
                  <div class="image">
                    <img
                      :src="coach.profile_pic"
                      :alt="fullname(coach.user)"
                    >
                  </div>
                  <div class="information">
                    <div class="name">
                      {{ coach.user.firstname }} {{ coach.user.lastname }}
                    </div>
                    <div class="function">
                      {{ coach.tag }}
                    </div>
                    <div class="price">
                      <span><b>$</b> {{ coachFees(coach.fees) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br>
          </div>
        </div>
        <div
          v-if="!loading"
          class="text-center"
        >
          <b-pagination
            v-model="page"
            hide-goto-end-buttons
            :total-rows="totalRows"
            :per-page="pageSize"
            limit="3"
            @change="handlePageChange"
          />
        </div>
      </div>
    </div>
    <div class="section-background primary  auto-height">
      <div class="container">
        <h2 class="title">
          <span>Reviews from our users</span>
          What does Charles Ashton say about Ludimos?
        </h2>

        <div class="row">
          <div class="col-xs-12 col-md-6">
            <iframe
              width="100%"
              height="350"
              src="https://www.youtube.com/embed/JjQqvrqoDUw?start=6"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </div>
          <div class="col-xs-12 col-md-6">
            <p>
              "I found Ludimos on a random google search when we had built our
              indoor cricket net at the start of the Coronavirus lockdown. We
              find Ludimos easy to use and will continue to use the app to
              support Ashton's club and Lancashire coaching sessions."
            </p>

            <p>
              "We are really loving the app and how Ashton has come on over the
              last few weeks. We can really see the difference. He is more than
              happy to spend hours and hours in the nets practising the same
              drill over and over again to perfect it."
            </p>
            <b>Emma Ashton</b>
            <br>
            <b>Mother of Charles Ashton</b>
          </div>
        </div>
      </div>
    </div>

    <div class="section-background padding-xl pt-0 auto-height">
      <div class="container">
        <div
          id="howItWorks"
          class="section-background auto-height"
        >
          <HowItWorks />
        </div>
        <div class="row d-flex justify-content-around align-items-center">
          <div class="col-md-8 text-md-left text-center">
            <span class="pre-foot">
              <b>Weekly</b> or <b>monthly</b> personalised sessions can be
              arranged if required
            </span>
          </div>
          <div class="col-md-4 text-md-left text-center">
            <a
              class="primary-button primary with-icon"
              href="mailto:hello@ludimos.com"
            >Contact us</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HowItWorks from "./HowItWorks.vue";
import CoachService from "@/services/coaches";
export default {
  name: "About",
  components: {
    HowItWorks,
  },
  data() {
    return {
      loading: false,
      coaches: [],
      page: 1,
      totalRows: 0,
      pageSize: 12,
      data: {},
      selected: [],
      options: [
        { text: "Option 1", value: "1" },
        { text: "Option 2", value: "2" },
        { text: "Option 3", value: "3" },
        { text: "Option 4", value: "4" },
      ],

      sortBy: 4,
      SortByOptions: [
        { value: "1", text: "Featured" },
        { value: "2", text: "Price: Low to High" },
        { value: "3", text: "Price: High to Low" },
        { value: "4", text: "Latest" },
      ],
      orderbyValues: ["created_at", "fees", "-fees", "-created_at"],
    };
  },
  watch: {
    sortBy(newValue) {
      this.sortBy = parseInt(newValue);
      this.page = 1;
      this.fetchData({});
    },
  },
  created() {
    this.fetchData({ _page: 1, _pageSize: this.pageSize });
  },
  async mounted() {
    // Tracking code
    this.$ma.trackEvent({
      fb_event: "ViewContent",
      category: "Menu",
      action: "Menu",
      label: "Coaches",
      type: "Coaches",
    });
  },
  methods: {
    trackHireClick() {
      this.$ma.trackEvent({
        fb_event: "Click",
        category: "Click",
        action: "Hire Coach",
        label: "From hero",
        type: "From Hero",
      });
    },
    trackHowWorksClick() {
      this.$ma.trackEvent({
        fb_event: "Click",
        category: "Click",
        action: "How it works",
        label: "From hero",
        type: "From Hero",
      });
    },
    fullname(user) {
      return `${user.firstname} ${user.lastname}`;
    },
    async handlePageChange(page) {
      const params = { _page: page, _pageSize: this.pageSize };
      this.page = page;
      this.fetchData(params);
    },

    async fetchData(params) {
      this.loading = true;
      const response = await CoachService.getCoaches(
        Object.assign(
          {
            _related: "user",
            _orderBy: this.orderbyValues[this.sortBy - 1],
            _page: this.page,
            _pageSize: this.pageSize,
          },
          params
        )
      );
      this.data = response.data;
      this.coaches = this.data.data;
      this.totalRows = response.data.numRows;
      this.page = response.data.page;
      this.loading = false;
    },
    coachFees(coachFee) {
      const fees = coachFee ? coachFee / 4 : 0;
      return fees ? `${fees.toFixed(2)}` : `Not Available`;
    },
    goToProfile(coach) {
      this.$router.push({
        name: "coach-profile",
        params: { id: coach.id },
        query: this.$route.query,
      });
    },
  },
  metaInfo() {
    return {
      title: this.textEllipsis(`Ludimos - Marketplace`, 25),
      // meta: [{ name: "theme-color", content: this.getPrimaryHex }]
    };
  },
};
</script>
<style lang="scss" scoped>
.hero .text .sub-title {
  text-transform: inherit;
}

.hero .text .title {
  font-size: 40px;
  text-transform: inherit;
}

.section-background {
  min-height: 0;
  .hero {
    min-height: 0;
  }
}

.usp-row {
  text-align: center;
  margin: 30px 0 0;
  .usp-holder {
    border-radius: 10px;
    padding: 20px;
    background: #fff;
    background: linear-gradient(0deg, #e0d6ff 0%, #eee8ff 100%);
    color: #2b3060;
  }
  i {
    font-size: 100px;
    color: #6f44ff;
  }

  p {
    font-weight: bold;
    font-size: 20px;
  }
  span {
    font-size: 14px;
  }
}

.filters {
  padding: 0;
}

.sort-by {
  select {
    max-width: 230px;
  }
}
.seo-text {
  p {
    margin: 0;
  }
}
.coach-card {
  padding: 10px;
  border-radius: 4px;
  transition: all 0.3s ease-in-out;
  background: #fff;
  color: #2b3060;
  margin: 20px 0 10px;
  display: flex;
  position: relative;
  cursor: pointer;
  border: 2px solid transparent;

  &:hover {
    border: 2px solid #eee;
  }

  .image {
    position: relative;
    width: 150px;
    height: 150px;
    min-width: 150px;
    min-height: 150px;
    margin: 0 15px 0 0;
    overflow: hidden;
    border-radius: 4px;

    img {
      min-width: 100%;
      max-height: 100%;
    }
  }
  .information {
    .name {
      font-weight: 600;
      font-size: 16px;
    }
    .function {
      font-size: 14px;
      opacity: 0.5;
    }
  }
  .price {
    background: #6f44ff;
    color: #fff;
    font-size: 20px;
    font-weight: 600;
    min-width: 70px;
    margin: 10px 0;
    padding: 4px 10px;
    border-radius: 4px;
    display: inline-block;

    b {
      font-size: 18px;
      font-weight: 600;
    }
    span {
      display: inline-block;
      &:nth-child(2) {
        font-size: 10px;
        font-weight: normal;
        margin-left: 4px;
      }
    }
  }
}

.session-description {
  opacity: 0.5;
  font-size: 11px;
}
.usps-wrapper {
  padding: 0;
  margin: 20px 0 0;
  font-size: 14px;
}
.usps {
  background: #6e44ff;
  color: #fff;
  padding: 20px 30px;
  list-style: none;
  display: flex;
  align-items: center;
  margin: 10px 0 0;
  border-radius: 4px;
  li {
    padding-right: 10px;
    margin-right: 10px;
    position: relative;
    display: flex;
    width: 33%;
    border-right: 1px dashed rgba(#2b2f60, 0.5);
    &:nth-child(1) {
      font-weight: 600;
      font-size: 20px;
      width: 40%;
      text-transform: uppercase;
      border: none;
      &:before {
        content: none;
      }
    }
    &:last-child {
      border: none;
      padding: 0;
      margin: 0;
    }
    &:before {
      content: "check";
      font-family: "Material Icons";
      font-size: 40px;
      margin: 0 10px 0 0;
      line-height: 1;
      opacity: 0.5;
      color: #2b2f60;
    }
  }
}

@media (max-width: 767px) {
  .usp-holder {
    margin: 0 0 20px;
    span {
      display: none;
    }
  }

  iframe {
    height: 200px;
  }

  .page-title {
    width: 100%;
    flex-basis: auto;
  }

  .filters-btn {
    float: none;
  }

  .seo-text {
    p {
      margin: 10px 0 0;
    }
  }

  .usps {
    display: block;
    width: 100%;
    padding: 20px;
    li {
      border-bottom: 1px dashed rgba(#2b2f60, 0.5);
      border-right: none;
      padding: 0 0 10px 0;
      margin: 0 0 10px;
      align-items: center;
      width: 100%;
      &:nth-child(1) {
        width: 100%;
        font-size: 17px;
      }
    }
  }

  .custom-hero-image {
    top: 50px;
  }

  .sort-by {
    select {
      max-width: 9999px;
      margin: 20px 0 0;
    }
  }
}
</style>
